// extracted by mini-css-extract-plugin
export var actionButton = "_pk-0";
export var actionMenuContainer = "_pk-i";
export var bubble = "_pk-2";
export var bubbleActionMenu = "_pk-j";
export var bubbleContext = "_pk-6";
export var bubbleItems = "_pk-7";
export var customer = "_pk-3";
export var divider = "_pk-8";
export var fileList = "_pk-9";
export var hiddenComment = "_pk-o";
export var infoAbove = "_pk-a";
export var internal = "_pk-4";
export var lightActionButton = "_pk-1";
export var link = "_pk-b";
export var merchant = "_pk-5";
export var message = "_pk-c";
export var profilePicture = "_pk-e";
export var quillToolbarContainer = "_pk-f";
export var senderDate = "_pk-g";
export var senderDateCustomer = "_pk-h";
export var senderName = "_pk-d";
export var time = "_pk-k";
export var uploadedImage = "_pk-l";
export var username = "_pk-m";
export var xsmall = "_pk-n";